import React from 'react'
// import { TransitionGroup, CSSTransition } from "react-transition-group";

import project from '../../project'
import Data from './Data'
import BreachCodes from './BreachCodes'
import { Tracking } from '../../../NodeModules/nnd-track-page'
import { Tracking219 } from './Tracking'
import VisibilitySensor from 'react-visibility-sensor'
import { ajaxSetup, getJSON } from 'jquery'

import "../assets/styles/home.scss"

ajaxSetup({ cache: true })

class Home extends React.Component {
  constructor(props) {
    super(props)
    this.scrollDiv = React.createRef()
    this.state = {
      firstInteraction: false,
      appInViewport: false,
      data: undefined,
      breach: null,
      SubscriptionUrl: '',
      siteDomain: '',
      siteCode: '',
      isMobApp: false
    }

    this.siteCode = this.siteCode.bind(this)
    this.checkBreach = this.checkBreach.bind(this)
    this.loadData = this.loadData.bind(this)
    this.visChange = this.visChange.bind(this)

    const thisState = this

    let appContainer = document.getElementById(`app_${project.name}`)
    appContainer.addEventListener('mouseenter', (f) => {
      if (!thisState.state.firstInteraction) {
        thisState.state.firstInteraction = true
        Tracking.trackPageImpression('firstinteraction', project.name)
      }
    })
    
  }

  componentDidMount () {
    this.checkBreach()
  }

  visChange (isVisible) {
    // console.log('Breach is now %s', isVisible ? 'visible' : 'hidden');
    if ( isVisible && this.state.appInViewport === false) {
      this.state.appInViewport = true
      Tracking219.trackBreachImpression('app In Viewport', project.name)
    }
  }

  siteCode (siteHostname) {
    let siteCode, siteDomain
    switch (siteHostname) {
      
      case 'www.adelaidenow.com.au' :
        siteCode = 'adv'
        siteDomain = 'adelaidenow'
        break
      
      case 'www.cairnspost.com.au' :
        siteCode = 'cp'
        siteDomain = 'cairnspost'
        break
      
      case  'www.couriermail.com.au' :
        siteCode = 'cm'
        siteDomain = 'couriermail'
        break
      
      case  'www.heraldsun.com.au' :
        siteCode = 'hs'
        siteDomain = 'heraldsun'
        break
      
      case  'www.geelongadvertiser.com.au' :
        rsiteCode = 'ga'
        siteDomain = 'geelongadvertiser'
        break
      
      case  'www.goldcoastbulletin.com.au' :
        siteCode = 'gcb'
        siteDomain = 'goldcoastbulletin'
        break

      case  'www.ntnews.com.au' :
        siteCode = 'ntn'
        siteDomain = 'ntnews'
        break
      
      case  'www.thechronicle.com.au' :
        siteCode = 'twc'
        siteDomain = 'thechronicle'
        break

      case  'www.themercury.com.au' :
        siteCode = 'merc'
        siteDomain = 'themercury'
        break
      
      case  'www.townsvillebulletin.com.au' :
        siteCode = 'tb'
        siteDomain = 'townsvillebulletin'
        break
      
      case  'www.weeklytimesnow.com.au' :
        siteCode = 'wtn'
        siteDomain = 'weeklytimesnow'
        break
      
      case  'www.dailytelegraph.com.au' :
        siteCode = 'dt'
        siteDomain = 'dailytelegraph'
        break

      case 'localhost' :
        siteCode = 'dt'
        siteDomain = 'dailytelegraph'
        break
    }
    this.setState({
      siteCode: siteCode,
      siteDomain: siteDomain
    })

    return siteCode

  }

  goLogin () {
    const loginButton = document.querySelectorAll('.header_log-in, .tgc-auth-buttons_login') // Mastheads, Regionals
    loginButton[0].click()
  }

  checkBreach () {

    if (window.DNA_APP_ENV) {
        
        if (window.DNA_APP_ENV.platform) {
          this.state.breach = false
          this.state.isMobApp = true
          this.loadData()

        } else {
          setTimeout(this.checkBreach, 250);
        }

    } 

    if (window.utag_data) {
      if( (typeof window.utag_data.net_platform !== "undefined") && (typeof window.utag_data.pc_memtype !== "undefined") ) {
          const currentDomain = window.location.hostname
          const currentUrl = window.location.href
          const netsite = this.siteCode(window.location.hostname)
          const netplatform = window.utag_data.net_platform
          const breachSourceCode = BreachCodes[netsite][netplatform]
          const subUrl = 'https://'
            + currentDomain
            + '/subscribe/news/1/'
            + '?sourceCode=' + breachSourceCode
            + '&dest=' + encodeURIComponent(currentUrl)
            + '&memtype=anonymous&mode=premium'

          this.state.SubscriptionUrl = subUrl
          this.state.breach = ( utag_data && utag_data.pc_memtype == "subscriber" ) ? false : true;
          this.loadData()

      }
      else {
          setTimeout(this.checkBreach, 250);
      }
    }
    
  }

  dataSlash () {
    let slashedData = this.state.data.slice(0, 3)
    this.setState({
      data: slashedData
    })
  }

  scroll2message () {
    this.scrollDiv.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  goSubscribe () {
    window.location.replace(this.state.SubscriptionUrl);
  }

  loadData () {
    
    this.setState({
      data: Data
    }, function () {
      if ( this.state.breach === true ) {
        this.dataSlash()
      }
    });
    
  }

  render() {
    const mylist = (typeof this.state.data !== 'undefined') ? this.state.data.map((item) => {
      if (typeof this.state.data !== 'undefined') {
        return (
         <div key={item.id} className={`nnd-row nnd-expert-${item.id}`}>
           <div className="nnd-col-rating"><span className="nnd-rating-expert">{ item.pos }</span></div>
           <div className="nnd-col-img">
             <picture>
               <source srcSet={require(`../assets/images/${item.imagename}.jpg`)} media="(min-width: 768px)" />
               <img srcSet={require(`../assets/images/${item.imagename}.jpg`)} src={require(`../assets/images/${item.imagename}.jpg`)} />
             </picture>
           </div>
           <div className="nnd-col-text">
             <h3>{ item.name }</h3>
             <h5><span>Club:</span> { item.club }</h5>
             <p><span>Position:</span> { item.position1 }</p>
             <p><span>2nd Position:</span> { item.position2 }</p>
             <p className="nnd-nopad"><span>SC Price:</span> { item.scprice }</p>
             <p className="nnd-nopad"><span>SC 2020 Avg:</span> { item.sc2020ave }</p>
             <p><span>What Tom Sangster says:</span> { item.experts }</p>
           </div>
           
         </div>
        )
      }
    }) : ''

    const isBreached = this.state.breach
    const isMobApp = this.state.isMobApp

    return (
      <div className={isBreached === true ? 'nnd-container nnd-breach' : 'nnd-container nnd-premium'} data-mobapp={isMobApp}>
        <div name="nnd-expert" className='nnd-cont-main'>
          {mylist}
        </div>

        {isBreached === true
          ? 
          <div id="nnd-breach-overlay" className="nnd-breach-overlay" ref={this.scrollDiv}>
            <div className="nnd-col-rating"><span className="nnd-rating-expert">FRF</span></div>
            <VisibilitySensor onChange={this.visChange} delayedCall='true'>
              <div className="nnd-breach-message">
                <p className="nnd-bm1"><span>There's more to this story. </span><span>Subscribe today to unlock this and more</span></p>
                <p className="nnd-bm2">Only $1 for the first 28 days</p>
                <a className="nnd-breachLink" onClick={(e) => { this.goSubscribe(e) }}>Subscribe</a>
                <p className="nnd-bm3"><a onClick={(e) => { this.goLogin(e); e.preventDefault() }}>Log in</a> | T&Cs apply</p>
              </div>
            </VisibilitySensor>
          </div>
          : ''
        }

      </div>
    )
  }
}

// {isBreached === false ? <div>BREACHED FALSE</div> : <div>BREACHED TRUE</div>} 
// <img className="nnd-logo" src={require(`../assets/images/logos/${this.state.siteDomain}-white.svg`)} />

export default Home


// WEBPACK FOOTER //
// ./src/components/Home.js